<template>
  <div
    class="flex min-h-10 min-w-10 items-center justify-center rounded-md"
    :class="{
      'min-h-7! min-w-7!': size === ComponentSize.sm,
      'text-accent-fgr-teal bg-accent-bgr-teal border-accent-bdr-teal border': color === ComponentColor.Teal,
      'text-accent-fgr-blue bg-accent-bgr-blue border-accent-bdr-blue border': color === ComponentColor.Blue,
      'text-accent-fgr-red bg-accent-bgr-red border-accent-bdr-red border': color === ComponentColor.Red,
      'text-accent-fgr-green bg-accent-bgr-green border-accent-bdr-green border': color === ComponentColor.Green,
      'text-accent-fgr-yellow bg-accent-bgr-yellow border-accent-bdr-yellow border': color === ComponentColor.Yellow,
      'text-accent-fgr-purple bg-accent-bgr-purple border-accent-bdr-purple border': color === ComponentColor.Purple,
      'text-accent-fgr-pink bg-accent-bgr-pink border-accent-bdr-pink border': color === ComponentColor.Pink,
      'text-accent-fgr-orange bg-accent-bgr-orange border-accent-bdr-orange border': color === ComponentColor.Orange,
      'text-accent-fgr-brown bg-accent-bgr-brown border-accent-bdr-brown border': color === ComponentColor.Brown,
    }"
  >
    <Icon :size="returnSize" :src="src" />
  </div>
</template>

<script setup lang="ts">
  const {
    size = undefined,
    src = undefined,
    color = undefined,
  } = defineProps<{
    size?: string;
    src?: string;
    color?: ComponentColor;
  }>();

  const returnSize = size === ComponentSize.sm ? ComponentSize.default : ComponentSize.xl;
</script>
